/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    RegisterTransactionDTO,
    RegisterTransactionDTOFromJSON,
    RegisterTransactionDTOToJSON,
    RegisterTransactionsDTO,
    RegisterTransactionsDTOFromJSON,
    RegisterTransactionsDTOToJSON,
    TransactionDTO,
    TransactionDTOFromJSON,
    TransactionDTOToJSON,
} from '../models';

export interface DeleteTransactionRequest {
    carePrincipalId: string;
    transactionId: string;
    reason?: string;
}

export interface RegisterTransactionRequest {
    registerTransactionDTO: RegisterTransactionDTO;
}

export interface RegisterTransactionsRequest {
    registerTransactionsDTO: RegisterTransactionsDTO;
}

export interface UpdateTransactionRequest {
    transactionDTO: TransactionDTO;
}

/**
 * 
 */
export class TransactionApi extends runtime.BaseAPI {

    /**
     */
    async deleteTransactionRaw(requestParameters: DeleteTransactionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.carePrincipalId === null || requestParameters.carePrincipalId === undefined) {
            throw new runtime.RequiredError('carePrincipalId','Required parameter requestParameters.carePrincipalId was null or undefined when calling deleteTransaction.');
        }

        if (requestParameters.transactionId === null || requestParameters.transactionId === undefined) {
            throw new runtime.RequiredError('transactionId','Required parameter requestParameters.transactionId was null or undefined when calling deleteTransaction.');
        }

        const queryParameters: any = {};

        if (requestParameters.reason !== undefined) {
            queryParameters['reason'] = requestParameters.reason;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/{carePrincipalId}/transaction/{transactionId}`.replace(`{${"carePrincipalId"}}`, encodeURIComponent(String(requestParameters.carePrincipalId))).replace(`{${"transactionId"}}`, encodeURIComponent(String(requestParameters.transactionId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async deleteTransaction(carePrincipalId: string, transactionId: string, reason?: string, initOverrides?: RequestInit): Promise<string> {
        const response = await this.deleteTransactionRaw({ carePrincipalId: carePrincipalId, transactionId: transactionId, reason: reason }, initOverrides);
        return await response.value();
    }

    /**
     */
    async registerTransactionRaw(requestParameters: RegisterTransactionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.registerTransactionDTO === null || requestParameters.registerTransactionDTO === undefined) {
            throw new runtime.RequiredError('registerTransactionDTO','Required parameter requestParameters.registerTransactionDTO was null or undefined when calling registerTransaction.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/transaction`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterTransactionDTOToJSON(requestParameters.registerTransactionDTO),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async registerTransaction(registerTransactionDTO: RegisterTransactionDTO, initOverrides?: RequestInit): Promise<string> {
        const response = await this.registerTransactionRaw({ registerTransactionDTO: registerTransactionDTO }, initOverrides);
        return await response.value();
    }

    /**
     */
    async registerTransactionsRaw(requestParameters: RegisterTransactionsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.registerTransactionsDTO === null || requestParameters.registerTransactionsDTO === undefined) {
            throw new runtime.RequiredError('registerTransactionsDTO','Required parameter requestParameters.registerTransactionsDTO was null or undefined when calling registerTransactions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/transactions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RegisterTransactionsDTOToJSON(requestParameters.registerTransactionsDTO),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async registerTransactions(registerTransactionsDTO: RegisterTransactionsDTO, initOverrides?: RequestInit): Promise<string> {
        const response = await this.registerTransactionsRaw({ registerTransactionsDTO: registerTransactionsDTO }, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateTransactionRaw(requestParameters: UpdateTransactionRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.transactionDTO === null || requestParameters.transactionDTO === undefined) {
            throw new runtime.RequiredError('transactionDTO','Required parameter requestParameters.transactionDTO was null or undefined when calling updateTransaction.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/efrikort/client/careprincipal/transaction/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: TransactionDTOToJSON(requestParameters.transactionDTO),
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async updateTransaction(transactionDTO: TransactionDTO, initOverrides?: RequestInit): Promise<string> {
        const response = await this.updateTransactionRaw({ transactionDTO: transactionDTO }, initOverrides);
        return await response.value();
    }

}
